export enum EPartnerCostsNewYearDataSource {
  previousYear = 'previousYear',
  blankValues = 'blankValues'
}
